import { RestrictionTypes } from '@client-monorepo/common/network';
import { StoreRestrictionFields } from '@client-monorepo/daily-fintech/stores';

export interface StoresFiltersModel {
  id: string;
  sectionName: string;
  sectionType?: StoresFilterSectionTypes;
  filters?: StoresSingleFilterModel[];
}

export enum StoresFilterSectionTypes {
  RADIO = 'RADIO',
  CHECKBOX = 'CHECKBOX',
  CATEGORY_ITEM = 'CATEGORY_ITEM',
}

export interface StoresSingleFilterModel {
  id: string;
  label: string;
  icon?: string;
  isSelected: boolean;
}

export const DefaultRestriction = {
  type: RestrictionTypes.SIMPLE,
  field: StoreRestrictionFields.IS_DEACTIVE,
  operation: 'eq',
  value: false,
};
